@import "../../../variables.scss";
$bar-color: #ba0000;

.profile {
  &__profileItem {
    font-family: Lato;
    font-style: normal;
    padding: 1rem;
    padding-left: 12px;
    &_inner {
      width: 60%;
    }
    &_incompleteMobile {
      border: 1px $bar-color solid;
    }
    &_wrapper {
      background-color: white;
      display: flex;
      position: relative;
      border: 1px solid #E2E8F0;
    }
    &_text {
      font-weight: bold;
      font-size: 17px;
      line-height: 22px;
      &_incomplete {
        padding-left: 2.5rem;
        display: flex;
      }
    }
    &_customItem {
      margin-left: 2.5rem;
      display: block;
      white-space: nowrap;
      @media (max-width: $size-lg) {
        padding-left: 0px !important;
      }
      @media (max-width: $size-sm) {
        text-align: center;
        width: 100%;
        margin-left: 0rem;
      }
    }
    &_icon {
      margin-right: 2rem;
      position: absolute;
      top: 33%;
      width: 30px;
      margin-left: 1rem;
    }
    &_button {
      font-weight: bold;
      font-size: 16px;
      line-height: 18px;
      padding-right: 7px;
      padding-left: 7px;
      width: 90px;
      &_custom {
        margin-left: 1.5rem;
        margin-top: 0.5rem;
        width: 140px;
      }
    }
    &_mobileHeader {
      @media (max-width: $size-sm) {
        flex-direction: column;
      }
    }
  }
  &__bar {
    border-right: 4px $bar-color solid;
    border-left: 4px white solid;
    margin-top: 4px;
    margin-bottom: 4px;
  }
}
